import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { Card, CardContent, Grid, Paper, 
  // TextField,
  // FormControl,
  // FormHelperText,

} from "@material-ui/core";

import {
  renderLockedTextField,
  renderTextField,
  renderDateTextField,
  renderSelectField6,
} from "../../form-global-components/components-form-components-for-react-final-form";
import { ETHNICITY_LIST, GENDER_LIST } from "../../../actions/action-constants";
class FormFieldsTabName extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dob: "",
      age: "",
    };
  }
  handleChangeDOB = (event) => {
    var dateDiff = this.getAge(event);
    this.setState({
      dob: event,
      age: dateDiff + " years old",
    });
  };
  getAge = (pDate) => {
    var selDate = pDate;
    var birthday = +new Date(selDate);
    var dateDiff = ~~((Date.now() - birthday) / 31557600000);
    return dateDiff;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps._reduxForm.values !== undefined) {
      var selDate = nextProps._reduxForm.values.dob;
      var birthday = +new Date(selDate);
      var dateDiff = ~~((Date.now() - birthday) / 31557600000);
      return { age: dateDiff };
    }
    return null;
  }

  render() {
    return (
      <div>
        <Paper>
          <Card>
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Field
                    disabled
                    component={renderTextField}
                    id="id"
                    name="id"
                    label="System ID #"
                    emptyText="Auto-generated by Database"
                    footerMessage="Auto-generated by Database"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    autoFocus
                    locked={this.props.locked}
                    component={renderTextField}
                    id="regid"
                    name="regid"
                    label="Crosspoint / Reg Pact ID #"
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                  <Field
                    locked={this.props.locked}
                    component={renderTextField}
                    id="fname"
                    name="fname"
                    label="First Name"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Field
                    locked={this.props.locked}
                    component={renderTextField}
                    id="mname"
                    name="mname"
                    label="Middle Name"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Field
                    locked={this.props.locked}
                    component={renderTextField}
                    id="lname"
                    name="lname"
                    label="Last Name"
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Field
                    locked={this.props.locked}
                    component={renderDateTextField}
                    id="dob"
                    name="dob"
                    label="Date Of Birth"
                    onChange={this.props.handleChangeDOB}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={renderLockedTextField}
                    id="age"
                    name="age"
                    label="Age"
                    setValue={this.state.age + " years old"}
                  />




{/*                   
                  <TextField
                    disabled
                    id="age"
                    name="age"
                    value={this.state.age + " years old"}
                    fullWidth
                    // variant="filled"
                  />
*/}


{/* 

                <FormControl fullWidth >
                  <TextField
                  id="age2"
                  name="age2"
                  required={false}
                  disabled={true}
                  label="Age"
                  value={this.state.age + " years old"}
                  fullWidth
                  variant='outlined'
                />
                <FormHelperText>
                </FormHelperText>
                </FormControl>
 */}


                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    locked={this.props.locked}
                    component={renderSelectField6}
                    id="gender"
                    name="gender"
                    label="Gender"
                    footerMessage=""
                    dataArray={GENDER_LIST}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    locked={this.props.locked}
                    component={renderSelectField6}
                    id="ethnicity"
                    name="ethnicity"
                    label="Ethnicity"
                    footerMessage=""
                    dataArray={ETHNICITY_LIST}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Paper>
      </div>
    );
  }
}
FormFieldsTabName.propTypes = {
  locked: PropTypes.bool,
};
export default FormFieldsTabName;
